import { getWindowSize } from '../../utils/helpers.js';

export default function videoWidget2() {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;
  const $widget = $(`#${widgetName}`);
  const isDesktop = getWindowSize(1170);

  const addVideoTag = false;
  const tagText = 'Watch';

  $widget.append('<iframe></iframe>');
  $widget.wrap('<div id="videoSection"></div>');
  addAosAnimation(isDesktop);

  $widget.videoWidget({
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    autoPlayVideo: false,
    loopVideo: true,
    maxVideos: 1,

    videoWidgetLoaded: function (data) {
      if (data?.Slides?.length >= 1) {
        if (addVideoTag) {
          $('#videoSection').append(`<div class="video-tag">${tagText}</div>`);
        }
      } else {
        $('#videoSection').remove();
        $('body').addClass('videoWidget-no-data');
      }
    },
  });
}

function addAosAnimation(isDesktop) {
  $('#videoSection').attr({
    'data-aos': isDesktop ? 'fade-left' : 'fade-down',
    'data-aos-delay': 800,
    'data-aos-easing': 'ease-in-out',
    'data-aos-duration': '500',
    'data-aos-once': 'true',
    'data-aos-offset': isDesktop ? '200' : '100',
  });
}
